import { render } from "./BoxWithStyle2.vue?vue&type=template&id=1662cc12&scoped=true"
import script from "./BoxWithStyle2.vue?vue&type=script&lang=js"
export * from "./BoxWithStyle2.vue?vue&type=script&lang=js"

import "./BoxWithStyle2.vue?vue&type=style&index=0&id=1662cc12&scoped=true&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/wanfei-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1662cc12"]])

export default __exports__